import * as React from 'react';
import { IErrors, IValues, IFormContext, FormContext } from '../form/Form';

//styles
import * as styles from './Field.sass';

/* The available editors for the field */
type Editor = 'textbox' | 'multilinetextbox' | 'dropdown';

export interface IValidation {
  rule: (values: IValues, fieldName: string, args: any) => string;
  args?: any;
}

export interface IFieldProps {
  /* The unique field name */
  id: string;

  /* The label text for the field */
  label?: string;

  /* The editor for the field */
  editor?: Editor;

  /* The drop down items for the field */
  options?: string[];

  /* The field value */
  value?: any;

  /* The field validator function and argument */
  validation?: IValidation;
}

export const Field: React.SFC<IFieldProps> = ({
  id,
  label,
  editor,
  options,
  value
}) => {
  /**
   * Gets the validation error for the field
   * @param {IErrors} errors - All the errors from the form
   * @returns {string[]} - The validation error
   */
  const getError = (errors: IErrors): string => (errors ? errors[id] : '');
  /**
   * Gets the inline styles for editor
   * @param {IErrors} errors - All the errors from the form
   * @returns {any} - The style object
   */
  const getEditorStyle = (errors: IErrors): any =>
    getError(errors) ? { borderColor: 'red', marginLeft: '10px' } : {};

  return (
    <FormContext.Consumer>
      {(context: IFormContext) => (
        <div className={styles.formGroup}>
          {label && <label htmlFor={id}>{label}</label>}

          {editor!.toLowerCase() === 'textbox' && (
            <input
              id={id}
              type="text"
              value={value}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                context.setValues({ [id]: e.currentTarget.value })
              }
              onBlur={() => context.validate(id)}
              className={styles.formControl}
              style={getEditorStyle(context.errors)}
            />
          )}

          {editor!.toLowerCase() === 'multilinetextbox' && (
            <textarea
              id={id}
              value={value}
              onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
                context.setValues({ [id]: e.currentTarget.value })
              }
              onBlur={() => context.validate(id)}
              className={styles.formControl}
              style={getEditorStyle(context.errors)}
            />
          )}

          {editor!.toLowerCase() === 'dropdown' && (
            <select
              id={id}
              name={id}
              value={value}
              onChange={(e: React.FormEvent<HTMLSelectElement>) =>
                context.setValues({ [id]: e.currentTarget.value })
              }
              onBlur={() => context.validate(id)}
              className={styles.formControl}
              style={getEditorStyle(context.errors)}
            >
              {options &&
                options.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
            </select>
          )}

          {getError(context.errors) && (
            <div style={{ color: 'red', fontSize: '80%', marginLeft: '10px' }}>
              <p>{getError(context.errors)}</p>
            </div>
          )}
        </div>
      )}
    </FormContext.Consumer>
  );
};
Field.defaultProps = {
  editor: 'textbox'
};
